// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__i32bI","notes":"Notes_notes__1OnJR","note":"Notes_note__1bM3O","markdown":"Notes_markdown__lgRlD"};